export default __webpack_public_path__ + "static/subset-Inter-SemiBold-eab549d26a10b4d231b8cc3284b04731.woff";